import { useEffect, useRef, useState } from "react";

export const formatStat = (s, v = s.value) =>
  `${s.prefix || ""}${Number(v).toLocaleString(undefined, { minimumFractionDigits: s.decimals || 0, maximumFractionDigits: s.decimals || 0 })}${s.suffix || ""}`;

export const CountUp = ({ stat, className = "", testid }) => {
  const ref = useRef(null);
  const [v, setV] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return undefined;
    }
    let raf;
    const io = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) {
        return;
      }
      io.disconnect();
      const start = performance.now();
      const tick = (t) => {
        const p = Math.min(1, (t - start) / 1400);
        setV(stat.value * (1 - Math.pow(1 - p, 3)));
        if (p < 1) raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    }, { threshold: 0.3 });
    io.observe(el);
    return () => {
      io.disconnect();
      cancelAnimationFrame(raf);
    };
  }, [stat.value]);

  return <span ref={ref} className={className} data-testid={testid}>{formatStat(stat, v)}</span>;
};

export default CountUp;
